<template>
  <div class="text-center">
    <v-overlay :color="this.$vuetify.theme.dark ? 'black' : 'white'">
      <div class="d-flex flex-column align-center justify-center mb-5">
        <v-progress-circular indeterminate size="70" :color="this.$vuetify.theme.dark ? 'white' : '#9D9D9D'" width="2"></v-progress-circular>
        <p :class="this.$vuetify.theme.dark ? 'body-small text-primary mt-4' : 'body-small text-secondary mt-4'" v-if="loadingMessage">{{ loadingMessage }}</p>
        <NtButton
          v-if="cancellable"
          type="primary"
          value="Cancel"
          size="small"
          class="mt-8"
          @click="closeOverlay"/>
      </div>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "FullLoader",
  props: ['loadingMessage', 'cancellable'],
  methods: {
    closeOverlay() {
      this.$emit('cancelLoading')
    }
  }
};
</script>
